import { Card, Flex } from '@radix-ui/themes';

export default function SkeletonCard() {
  return (
    <Card
      role="status"
      aria-label="Loading integration"
      aria-live="polite"
      style={{
        position: 'relative',
        borderRadius: '12px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      }}
    >
      <Flex direction="column" gap="4" style={{ padding: '16px' }}>
        {/* Header: Icon + Status */}
        <Flex justify="between" align="center">
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '10px',
              backgroundColor: '#e5e7eb',
            }}
          />
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: '#e5e7eb',
            }}
          />
        </Flex>

        {/* Body: Name + Metadata */}
        <Flex direction="column" gap="2">
          <div
            style={{
              height: '20px',
              width: '60%',
              borderRadius: '4px',
              backgroundColor: '#e5e7eb',
            }}
          />
          <div
            style={{
              height: '14px',
              width: '40%',
              borderRadius: '4px',
              backgroundColor: '#e5e7eb',
            }}
          />
        </Flex>

        {/* Footer: Actions */}
        <Flex
          gap="2"
          justify="start"
          style={{
            borderTop: '1px solid rgba(0, 0, 0, 0.05)',
            paddingTop: '12px',
          }}
        >
          <div
            style={{
              height: '28px',
              flex: 1,
              borderRadius: '4px',
              backgroundColor: '#e5e7eb',
            }}
          />
          <div
            style={{
              height: '28px',
              width: '28px',
              borderRadius: '4px',
              backgroundColor: '#e5e7eb',
            }}
          />
        </Flex>
      </Flex>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
    </Card>
  );
}
